import React from 'react';
import { TableCell, TableHead, TableRow } from '@material-ui/core';

const rows = [
  { id: 'reference', label: 'Référence' },
  { id: 'description', label: 'Description' },
  { id: 'carrier', label: 'Transporteur' },
  { id: 'deliveryDate', label: 'Livraison' },
  { id: 'quantity', label: 'Contrôlé' },
  { id: 'state', label: 'État' }
];

/**
 * Entête du tableau dans la section des opérations
 */
const EnhancedTableHead = () => (
  <TableHead>
    <TableRow>
      {rows.map(
        row => (
          <TableCell key={row.id} align="left" style={{ fontWeight: 'bold' }}>
            {row.label}
          </TableCell>
        ),
        this
      )}
    </TableRow>
  </TableHead>
);

export default EnhancedTableHead;
